import React from 'react';
import { Link } from 'react-router-dom';

import logo from '../img/cfvn-logo.svg';
import logoDark from '../img/cfvn-logo-dark.svg';

const Logo = ({ homeLocation = '/', isDefault, className, width, height }) => (
  <Link to={homeLocation}>
    {isDefault ? (
      <img
        src={logo}
        width={width}
        height={height}
        alt="CrossFit Varna Logo"
        className={className}
      />
    ) : (
      <img
        src={logoDark}
        width={width}
        height={height}
        alt="CrossFit Varna Logo"
        className={className}
      />
    )}
  </Link>
);

export default Logo;
